<div class="row mt-5">
    <div class="offset-md-3 col-md-6 text-center">
        <mat-icon class="text-muted" style="transform: scale(4)">warning</mat-icon>
    </div>
</div>
<div class="row mt-5">
    <div class="offset-md-4 col-md-4 text-muted text-center">
        {{'dashboard.create_asset_hint' | transloco}}
    </div>
</div>
<div class="row mt-3">
    <div class="col text-center">
        <button mat-stroked-button color="primary" (click)="defineAssetClick.emit($event)">
            {{'dashboard.define_asset' | transloco}}
        </button>
    </div>
</div>
